// src/pages/Dashboard.js
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboard } from "store/dashboardSlice";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const dispatch = useDispatch();
  const { webinars, loading, error } = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(fetchDashboard());
  }, [dispatch]);

  return (
    <>

<div
  className={
    "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white"
  }
>
  {/* Header */}
  <div className="rounded-t mb-0 px-4 py-3 border-0">
    <div className="flex flex-wrap items-center">
      <div className="relative w-full px-4 max-w-full flex-grow flex-1">
        <h3 className="font-semibold text-lg text-blueGray-700">
          My Webinars
        </h3>
      </div>
    </div>
  </div>

  {loading && <p>Loading webinars...</p>}
  {error && <p className="text-red-500">{error}</p>}

  {/* Table */}
  <div className="block w-full overflow-x-auto">
    <table className="items-center w-full bg-transparent border-collapse">
      <thead>
        <tr>
          {["ID","Title","Start Time","Capacity","Registered","Revenue","Actions"].map((heading, idx) => (
            <th
              key={idx}
              className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
            >
              {heading}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {webinars.map((webinar) => (
          <tr key={webinar.id}>
            <td className="border-t-0 px-6 py-4 text-sm">{webinar.id}</td>
            <td className="border-t-0 px-6 py-4 text-sm">{webinar.title}</td>
            <td className="border-t-0 px-6 py-4 text-sm">
              {new Date(webinar.start_time).toLocaleString()}
            </td>
            <td className="border-t-0 px-6 py-4 text-sm">{webinar.capacity}</td>
            <td className="border-t-0 px-6 py-4 text-sm">{webinar.registered_count}</td>
            <td className="border-t-0 px-6 py-4 text-sm">${webinar.revenue}</td>
            <td className="border-t-0 px-6 py-4 text-sm">
              <Link
                to={`/admin/webinars/${webinar.id}/attendees`}
                className="bg-yellow-500 text-white px-3 py-1 hover:bg-yellow-600"
              >
                View Attendees
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

    </>
  );
}
